import { useAppSelector } from '@/redux/store'
import { Platform } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const CUSTOM_TAB_BAR_CONTENT_HEIGHT = 64

/** The 「问问 Jiri…」 bar the custom tab bar carries above its buttons: its height, and the gap below it. */
export const JIRI_BAR_HEIGHT = 40
export const JIRI_BAR_GAP = 8

export default function useCustomTabBarHeight() {
  const insets = useSafeAreaInsets()
  const jiriMobile = useAppSelector(state => state.session.jiriMobile)

  if (Platform.OS === 'ios') return 0

  const jiriBar = jiriMobile ? JIRI_BAR_HEIGHT + JIRI_BAR_GAP : 0
  return CUSTOM_TAB_BAR_CONTENT_HEIGHT + jiriBar + Math.max(insets.bottom, 8)
}
